module.exports = __webpack_public_path__ + "img/lang-1.4e61c221.jpg";